/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import { Formik } from 'formik';
import { get, isEmpty, isObject } from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { useNavigate, useParams } from 'react-router';
import Select from 'react-select';
import { toast } from 'react-toastify';
import placeholder from '../../../../assets/img/ogImage.jpeg';
import { LOCAL_STORAGE_KEYS } from '../../../../global/const';
import Thumbnail from '../../../components/ThumbnailComponent';
import FormikPlaceSearch from '../../../components/UI/FormikPlaceSearch';
import TextInput from '../../../components/UI/TextInput';
import PageLoader from '../../../components/loaders/PageLoader';
import { convertJsonToFormData } from '../../../helpers/helper';
import { GET, POST, PUT } from '../../../services/rest.service';
import JobPostingUpdateSchema from '../../../validationSchema/job-posting/JobPostingUpdateSchema';

const JobPostingUpdate = () => {
  const [records, setRecords] = useState({});
  const [status, setStatus] = useState('');
  const [open, setOpen] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState();
  const [nanniesId, setNanniesId] = useState('');
  const [nanniesList, setNanniesList] = useState([]);
  const [selectedOptionNannies, setSelectedOptionNannies] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();

  const openDialog = () => {
    setOpen(true);
  };

  const getJob = async () => {
    try {
      const { data } = await GET(`/admin/job-posting/getById/${id}`);
      setRecords(data);
      setStatus(data.status);
      setNanniesList(
        data.applications
          ? data.applications.map((x) => {
              return {
                value: x._id,
                label: x.name,
              };
            })
          : [],
      );
      setSelectedOptionNannies(
        data.filledBy && {
          value: data.filledBy._id,
          label: data.filledBy.name,
        },
      );
    } catch (err) {
      toast.error(err.message);
    }
  };

  useEffect(() => {
    getJob();
  }, []);

  const statusChange = (e) => {
    setStatus(e.target.value);
    if (status === 'Filled') {
      openDialog();
    }
  };

  const handleUpdateJobListingData = async (values) => {
    if (values.start_date) {
      const payload = {
        title: values.job_title,
        approxStartDate: moment(values.start_date, 'MM-DD-YYYY').format('YYYY-MM-DD'), // format: 2019-10-01 (YYYY-MM-DD)
        type: values.type, // "Fulltime", "Parttime", "Livein"
        location: isObject(values.location) ? values.location : records.location,
        city: values.city,
        jobDescription: values.job_description,
        rate: values.rate,
        status: status,
        filledBy: selectedOptionNannies && selectedOptionNannies.value ? selectedOptionNannies.value : '',
        seo: {
          title: values.title,
          description: values.description,
          image: {
            name: values.image,
            mimeType: values.mimeType,
          },
        },
      };

      try {
        await PUT(`/admin/job-posting/edit/${records._id}`, payload);
        toast.success('Job Post updated!');
        navigate(-1);
      } catch (err) {
        toast.error(err.message);
      }
    } else {
      toast.error('Please Select Start Date');
    }
  };

  const handleOnChangeNannies = (selectedOptionNannies) => {
    if (isObject(selectedOptionNannies)) {
      setSelectedOptionNannies(selectedOptionNannies);
      setNanniesId(selectedOptionNannies.value);
    } else {
      setNanniesId('');
      setSelectedOptionNannies(null);
    }
  };

  const editorConfig = {
    toolbar: ['heading', '|', 'bold', 'italic', 'bulletedList', 'numberedList'],
    heading: {
      options: [
        {
          model: 'paragraph',
          title: 'Paragraph',
          class: 'ck-heading_paragraph',
        },
        {
          model: 'heading1',
          view: 'h1',
          title: 'Heading 1',
          class: 'ck-heading_heading1',
        },
        {
          model: 'heading2',
          view: 'h2',
          title: 'Heading 2',
          class: 'ck-heading_heading2',
        },
      ],
    },
  };

  if (isEmpty(records)) {
    return <PageLoader />;
  }

  return (
    <React.Fragment>
      <div className="container-fluid px-xl-5">
        <section className="py-5">
          <div className="row">
            <div className="col-lg-10 col-xl-8 mb-5">
              <div className="card">
                <div className="card-header">
                  <h3 className="h6 text-uppercase mb-0">Update Job Posting</h3>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <Formik
                        initialValues={{
                          start_date: records && moment(records.approxStartDate, 'YYYY-MM-DD').format('MM-DD-YYYY'),
                          job_title: records.title,
                          type: records.type,
                          location: isObject(records.location) ? records.location.address : records.location,
                          job_description: records.jobDescription,
                          rate: records.rate,
                          status: records.status,
                          city: records.city,
                          title: get(records, 'seo.title'),
                          description: get(records, 'seo.description'),
                          image: get(records, 'seo.image.name'),
                          mimeType: get(records, 'seo.image.mimeType'),
                          url: get(records, 'seo.image.url'),
                        }}
                        onSubmit={(values) => {
                          handleUpdateJobListingData(values);
                        }}
                        validationSchema={JobPostingUpdateSchema}
                      >
                        {(renderProps) => {
                          const { values, touched, errors, handleChange, handleBlur, setFieldValue, handleSubmit } = renderProps;
                          return (
                            <form
                              onSubmit={handleSubmit}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') e.preventDefault();
                              }}
                            >
                              <div className="row">
                                <div className="form-group col-12 col-lg-6">
                                  <label className="form-label">Job Title</label>
                                  <TextInput
                                    label={''}
                                    labelClasses={''}
                                    placeholder={'Job Title'}
                                    value={values.job_title}
                                    error={touched.job_title && errors.job_title}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name={'job_title'}
                                    id={'job_title'}
                                  />
                                </div>
                                <div className="form-group col-12 col-lg-6">
                                  <label className="form-label">Approx. Start Date</label>
                                  <DatePicker
                                    className={'form-control mb-3'}
                                    placeholderText={'Please select approx start date'}
                                    showYearDropdown
                                    value={values.start_date}
                                    onChange={(value) => setFieldValue('start_date', moment(value).format('MM-DD-YYYY'))}
                                  />
                                </div>
                                <div className="form-group col-12 col-lg-6">
                                  <label className="form-label">Type</label>

                                  <select id="type" name="type" className="form-control mb-3" value={values.type} onChange={handleChange} onBlur={handleBlur}>
                                    <option value={'Full Time'}>Full Time</option>
                                    <option value={'Part Time'}>Part Time</option>
                                    <option value={'Live In'}>Live In</option>
                                  </select>
                                </div>
                                <div className="form-group col-12 col-lg-6">
                                  <FormikPlaceSearch
                                    id={'location'}
                                    name={'location'}
                                    label={'Location'}
                                    labelClasses={''}
                                    onChange={(e) => {
                                      const place = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.LOCATION));
                                      setFieldValue('location', place);
                                      setTimeout(() => {
                                        localStorage.removeItem(LOCAL_STORAGE_KEYS.LOCATION);
                                      }, 100);
                                    }}
                                    value={values.location}
                                    placeholder={'Please enter location'}
                                    error={touched.location && errors.location}
                                  />
                                </div>
                                <div className="form-group col-12 col-lg-6">
                                  <label className="form-label">City</label>

                                  <select id="city" name="city" className="form-control mb-3" value={values.city} onChange={handleChange} onBlur={handleBlur}>
                                    <option value={'All'}>ALL</option>
                                    <option value={'Austin'}>Austin, TX</option>

                                    <option value={'New York'}>New York, NY</option>
                                    <option value={'Los Angeles'}>Los Angeles, LA</option>
                                  </select>
                                </div>

                                <div className="form-group col-12 col-lg-6">
                                  <label className="form-label">Rate</label>
                                  <TextInput
                                    label={''}
                                    labelClasses={''}
                                    placeholder={'Rate'}
                                    value={values.rate}
                                    error={touched.rate && errors.rate}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name={'rate'}
                                    id={'rate'}
                                  />
                                </div>
                                <div className="form-group col-12 col-lg-6">
                                  <label className="form-label">Status</label>

                                  <select id="status" name="status" className="form-control mb-3" value={status} onChange={statusChange}>
                                    <option value={'Open'}>Open</option>
                                    <option value={'On Hold'}>On Hold</option>
                                    <option value={'Filled'} disabled={records.applications.length === 0}>
                                      Filled
                                    </option>
                                    <option value={'Cancelled'}>Cancelled</option>
                                  </select>
                                </div>
                                {status === 'Filled' && nanniesList.length > 0 && (
                                  <div className="form-group col-12 col-lg-6">
                                    <label className="form-label">Select Nannies</label>
                                    <Select
                                      value={selectedOptionNannies}
                                      isClearable={true}
                                      placeholder="Select Nannies"
                                      options={nanniesList}
                                      onChange={handleOnChangeNannies}
                                      className="mb-3"
                                    />
                                  </div>
                                )}

                                <div className="form-group col-12">
                                  <label className="form-label">Job Description</label>
                                  <CKEditor
                                    className="texteditor"
                                    config={editorConfig}
                                    editor={ClassicEditor}
                                    data={values.job_description}
                                    onChange={(event, editor) => {
                                      const data = editor.getData();
                                      setFieldValue('job_description', data);
                                    }}
                                  />
                                  <div className="mb-3" />
                                </div>
                                <div className="form-group col-12 my-4">
                                  <hr />
                                  <h3 className="h6 text-uppercase mb-0">SEO Details</h3>
                                </div>
                                <div className="form-group col-12 col-lg-6">
                                  <label className="form-label">Title</label>
                                  <TextInput
                                    label={''}
                                    labelClasses={''}
                                    placeholder={'Title'}
                                    value={values.title}
                                    error={touched.title && errors.title}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name={'title'}
                                    id={'title'}
                                  />
                                </div>

                                <div className="form-group col-12 col-lg-6">
                                  <label className="form-label">Description</label>
                                  <TextInput
                                    label={''}
                                    labelClasses={''}
                                    placeholder={'Description'}
                                    value={values.description}
                                    error={touched.description && errors.description}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name={'description'}
                                    id={'description'}
                                  />
                                </div>
                                <div className="col-lg-3">
                                  <label>Image</label>

                                  <div className="user-avatar">
                                    <label htmlFor="skill">
                                      <Thumbnail
                                        source={values.url}
                                        style={{
                                          width: '150px',
                                          height: '150px',
                                        }}
                                        placeHolderImage={placeholder}
                                        className="rounded-circle mx-3 my-2 my-lg-0 img-fluid c-pointer"
                                      />
                                    </label>
                                    {values.image && (
                                      <IconButton
                                        color="secondary"
                                        aria-label="Delete"
                                        onClick={() => {
                                          setFieldValue('image', '');
                                          setFieldValue('mimeType', '');
                                        }}
                                      >
                                        <DeleteIcon />
                                      </IconButton>
                                    )}
                                    <input
                                      id={'skill'}
                                      type="file"
                                      className="d-none"
                                      onChange={async (e) => {
                                        const document = e.target.files[0];
                                        const payload = convertJsonToFormData({ image: document });
                                        try {
                                          const res = await POST('/admin/job-posting/seoImageUpload', payload);
                                          setFieldValue('image', get(res, 'data.name'));
                                          setFieldValue('mimeType', get(res, 'data.mimeType'));
                                          setFieldValue('url', get(res, 'data.url'));
                                        } catch (err) {
                                          toast.error(err.message);
                                        }
                                      }}
                                    />
                                  </div>
                                </div>

                                <div className="form-group col-12">
                                  <button type="submit" onClick={handleSubmit} className="btn btn-primary btn-lg ">
                                    Update
                                  </button>
                                </div>
                              </div>
                            </form>
                          );
                        }}
                      </Formik>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
};

export default JobPostingUpdate;
